import React, { useState } from "react";
import Accordion from "../../../components/reuseable_comp/accordion/Accordion";
import "../../page_content.css";

const OfficerLikeQualities = () => {
  const [activeIndex, setactiveIndex] = useState(null);
  const [activeButton, setActiveButton] = useState(null);

  const handleToggle = (index) => {
    setactiveIndex(activeIndex === index ? null : index);
    setActiveButton(null); // reset button state when accordion changes
  };

  const toggleButton = (index) => {
    setActiveButton(activeButton === index ? null : index);
  };

  return (
    <div>
      <h1 className="title">Officer Like Qualities</h1>
      <hr />
<div className="page-content-container">
      {/* Accordion 1 - 4 Column Table */}
      <Accordion
        title="Basic Information"
        isActive={activeIndex === 0}
        onClick={() => handleToggle(0)}
      />
      {activeIndex === 0 && (
        <div className="accordion-content">
          <table className="page-content-table ">
            <thead>
              <tr>
                <th>Semester</th>
                <th>Course Name</th>
                <th>Total Marks</th>
                <th>Evaluation</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>All Semesters</td>
                <td>Officer Like Qualities</td>
                <td>100 for each semester</td>
                <td className="vertical-cell">
                  {">90% Excellent"} <br />
                  80 to 89% Very Good <br />
                  70 to 79% Good <br />
                  60 to 69% Average <br />
                  59% Poor
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {/* Accordion 2 - Text */}
      <Accordion
        title="Objective"
        isActive={activeIndex === 1}
        onClick={() => handleToggle(1)}
      />
      {activeIndex === 1 && (
        <div className="accordion-content">
          <p>To instill Officer Like Qualities in the Cadets</p>
        </div>
      )}

      {/* Accordion 3 - Title & Text */}
      <Accordion
        title="How The System Works"
        isActive={activeIndex === 2}
        onClick={() => handleToggle(2)}
      />
      {activeIndex === 2 && (
        <div className="accordion-content">
          <h4 className="innerpage-subheading">Awards of OLQ Credit Marks</h4>
          <ul className="page-content-lists">
            <li>
              As per the requirement of the Merchant Shipping Industry, all
              maritime students are imparted training for the development of
              personality and skills in organizational management.
            </li>
            <li>
              Every semester, cadets will be assessed for OLQ. Every
              student/cadet is required to actively participate in various
              activities of the institute, as well as various co-curricular and
              extra-curricular activities. OLQ marks will be awarded for all
              activities, and deductions will be made for indiscipline.
            </li>
            <li>
              The total OLQ marks allotted for each semester will be divided
              into three groups (A, B, and C). Cadets can earn a maximum amount
              of OLQ marks in each group by participating in the mentioned
              extra-curricular or co-curricular activities under each group.
            </li>
            <li>
              OLQ marks will be assimilated by the faculty-in-charge of the
              respective fields and finally awarded by the marine professor in
              charge of Cadet activities. The Principal's decision will be final
              for any moderation or review if needed.
            </li>
            <li>
              OLQ marks will reflect in each semester mark sheet but will not be
              added to the overall marks.
            </li>
          </ul>
        </div>
      )}

      {/* Accordion 4 - Title + 3 Buttons + Tables */}
      <Accordion
        title="Marking System"
        isActive={activeIndex === 3}
        onClick={() => handleToggle(3)}
      />
      {activeIndex === 3 && (
        <div className="accordion-content">
          <p>
            In group 'A' each cadet is given 50 marks at start of semester, and
            deductions from this will be carried out as per deduction heads
            below. He should strive to retain maximum marks.
          </p>

          {/* Buttons */}
          <div className="page-content-btns"  style={{ width: "min(800px, 100%)" }}>
            {[
              "GROUP A - Maximum 50\n(Deduction Heads)",
              "GROUP B - Maximum 20\n(Reward Heads)",
              "GROUP C - Maximum 30 \n(Reward Heads)",
            ].map((label, index) => (
              <button
                key={index}
                className={`page-content-btn ${
                  activeButton === index ? "active" : ""
                }`}
                onClick={() => toggleButton(index)}
              >
                {label}
              </button>
            ))}
          </div>

          {/* Tables for each button */}
          {activeButton === 0 && (
            <div>
              <table className="page-content-table " >
                <thead>
                  <tr>
                    <th>For every occasion</th>
                    <th>Maximum</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Missing from Muster</td>
                    <td>0.5</td>
                  </tr>
                  <tr>
                    <td>Missing from PT</td>
                    <td>0.5</td>
                  </tr>
                  <tr>
                    <td>Missing from Class</td>
                    <td>0.5</td>
                  </tr>
                  <tr>
                    <td>Late from Vacation</td>
                    <td>10</td>
                  </tr>
                  <tr>
                    <td>Late from Night out</td>
                    <td>5</td>
                  </tr>
                  <tr>
                    <td>Grooming</td>
                    <td>1.5</td>
                  </tr>
                  <tr>
                    <td>Unauthorized absence from hostel</td>
                    <td>10</td>
                  </tr>
                  <tr>
                    <td>Suspension - up to 3 days</td>
                    <td>20</td>
                  </tr>
                  <tr>
                    <td>Suspension - more than 3 days</td>
                    <td>30</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}

          {activeButton === 1 && (
            <div>
              <table className="page-content-table" >
                <thead>
                  <tr>
                    <th>For every occasion</th>
                    <th>Maximum</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Hostel Inspection</td>
                    <td>5</td>
                  </tr>
                  <tr>
                    <td>Divisions</td>
                    <td>5</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}

          {activeButton === 2 && (
            <div>
              <table className="page-content-table " >
                <thead>
                  <tr>
                    <th>For every occasion</th>
                    <th>Maximum</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Parade, Guard of Honor</td>
                    <td>5</td>
                  </tr>
                  <tr>
                    <td>Band</td>
                    <td>5</td>
                  </tr>
                  <tr>
                    <td>Sports - Athletics</td>
                    <td>3</td>
                  </tr>
                  <tr>
                    <td>Sports Athletics - Winners</td>
                    <td>7</td>
                  </tr>
                  <tr>
                    <td>Sports - Games - College Team</td>
                    <td>10</td>
                  </tr>
                  <tr>
                    <td>Sports - Games - House Team</td>
                    <td>5</td>
                  </tr>
                  <tr>
                    <td>Mess Committee</td>
                    <td>10</td>
                  </tr>
                  <tr>
                    <td>External Representation - Co-curricular</td>
                    <td>5</td>
                  </tr>
                  <tr>
                    <td>Cultural Activities</td>
                    <td>10</td>
                  </tr>
                  <tr>
                    <td>Rank Holders - SCC</td>
                    <td>30</td>
                  </tr>
                  <tr>
                    <td>Rank Holders - CC</td>
                    <td>25</td>
                  </tr>
                  <tr>
                    <td>Rank Holders - CL</td>
                    <td>20</td>
                  </tr>
                  <tr>
                    <td>Rank Holders - LC (Class Monitor)</td>
                    <td>10</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
    </div>
  );
};

export default OfficerLikeQualities;
